import React from 'react';
import RA from '../assets/gallery/RequestAppointment.jpg';
import FYD from '../assets/gallery/FindYourDoctor.jpg';
import BHC from '../assets/gallery/BookHelathCheck.jpg';
import SO from '../assets/gallery/SecondOpinion.jpg';
import BODC from '../assets/gallery/BookOnlineDoctorCosultation.jpg';

const ImageGallery = () => {
  // Array of image URLs or imports
  const images = [
    RA,
    FYD,
    BHC,
    SO,
    BODC,
  ];

  return (
    <div className="flex justify-start items-center space-x-2 p-4 overflow-x-auto">
      {images.map((image, index) => (
        <div
          key={index}
          // className="flex-none w-72 h-16 border rounded-md overflow-hidden shadow-md cursor-pointer"
          className="flex-none w-72 h-16 border rounded-md overflow-hidden shadow-md cursor-pointer transform transition-all duration-300 hover:scale-105"
        >
          <img
            src={image}
            alt={`Gallery Image ${index + 1}`}
            className="w-full h-full object-contain"
          />
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;
